import { reducer } from "./slice";

export default reducer;
